import { useEffect, useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import ContentZone from './components/ContentZone';
import Highlight from './components/Highlight';
import FaqSubscribe from './components/FaqSubscribe';

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 900);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <ContentZone />
      <Highlight />
      <FaqSubscribe />
      <Footer />

      {/* back to top */}
      <a
        href="#top"
        aria-label="返回顶部"
        className={`fixed bottom-6 right-5 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-foreground-950 text-background-50 shadow-none transition-all duration-300 hover:bg-primary-600 md:right-8 ${
          showTop ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-4 opacity-0'
        }`}
      >
        <i className="ri-arrow-up-line"></i>
      </a>
    </main>
  );
}